import { isTokenExpired } from "./AccessControlUtils";

export function isDevAuthSkipEnabled() {
  return (
    import.meta.env.DEV &&
    import.meta.env.VITE_SKIP_AUTH === "true"
  );
}

/**
 * Fetch a dev JWT from the local backend (GET /auth/dev-token).
 * Only runs when VITE_SKIP_AUTH=true in Vite dev mode.
 * @param {string} [roleOverride] e.g. "audiologist" on /audiologist/login
 */
export async function ensureDevAuthToken(roleOverride) {
  if (!isDevAuthSkipEnabled()) return false;

  const existing = localStorage.getItem("authToken");
  if (existing && !isTokenExpired()) return true;
  if (existing) localStorage.removeItem("authToken");

  const baseUrl = (import.meta.env.VITE_BASE_URL || "").replace(/\/$/, "");
  if (!baseUrl) {
    console.warn("[devAuth] VITE_BASE_URL is not set");
    return false;
  }

  const role =
    roleOverride || import.meta.env.VITE_DEV_AUTH_ROLE || "admin";

  try {
    const res = await fetch(`${baseUrl}/auth/dev-token?role=${encodeURIComponent(role)}`);
    if (!res.ok) {
      console.warn("[devAuth] dev-token request failed:", res.status);
      return false;
    }
    const body = await res.json();
    const token = body?.data?.token;
    if (!token) return false;
    localStorage.setItem("authToken", token);
    return true;
  } catch (err) {
    console.warn("[devAuth] dev-token fetch error:", err);
    return false;
  }
}
